import * as React from 'react';
import Chip from '@mui/joy/Chip';
import List from '@mui/joy/List';
import ListSubheader from '@mui/joy/ListSubheader';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';


import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import WalletRoundedIcon from '@mui/icons-material/WalletRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import { Link, useLocation } from 'react-router-dom';
import { IconButton, Stack, Tooltip } from '@mui/joy';
import { useAuth } from '@providers/AuthProvider';

export default function Navigation({onClose = () => {}}) {
    const { hash, pathname, search } = useLocation();
    const { can, user } = useAuth();

    // todo: user perms to determine what we can actually see
    let navItems = [
        {
            name: 'Home',
            link: '/dashboard',
            icon: HomeRoundedIcon,
            color: 'neutral',
        },
        {
            name: 'Contacts',
            link: '/contacts',
            icon: PeopleRoundedIcon,
            color: 'contact',
            hasPermission: can('view basic contacts') || can('view contacts'),
        },
        {
            name: 'Work Plans',
            link: '/work-plans',
            icon: ChecklistRoundedIcon,
            color: 'workplan',
        },
        {
            name: 'Businesses',
            link: '/businesses',
            icon: StoreRoundedIcon,
            color: 'business',
            hasPermission: can('view basic businesses') || can('view businesses'),
        },
        {
            name: 'Properties',
            link: '/properties',
            icon: ApartmentRoundedIcon,
            color: 'property',
            hasPermission: can('view basic properties') || can('view properties'),
        },
        {
            name: 'Events',
            link: '/events',
            icon: CalendarMonthRoundedIcon,
            color: 'event',
        },
        {
            name: 'Volunteer Opportunities',
            link: '/opportunities',
            icon: Diversity3RoundedIcon,
            color: 'neutral',
            hasPermission: can('view basic work plans') || can('view work plans'),
        },
        {
            name: 'Donations',
            link: '/donations',
            icon: WalletRoundedIcon,
            color: 'neutral',
            hasPermission: can('view basic donations') || can('view donations'),
        },
        {
            name: 'Reports',
            link: '/reports',
            icon: QueryStatsRoundedIcon,
            color: 'neutral',
            hasPermission: can('edit reports'),
        },
        {
            name: 'More...',
            link: '/tools/organization-settings',
            icon: ConstructionRoundedIcon,
            color: 'neutral',
            hasPermission: can('edit basic settings') || can('edit settings'),
        },
    ];

    return (<>
        {/* This is for the desktop menu */}
        <Stack
            spacing={1.5}
            sx={{
                display: {xs: 'none', md: 'flex'}
            }}
            useFlexGap
        >
            {navItems.map(navItem => {
                const isSelected = pathname.indexOf(navItem.link) !== -1;

                const hasAccess = navItem.hasOwnProperty('hasPermission') ? navItem.hasPermission === true : true;

                if(!hasAccess) {
                    return null;
                }

                return (<React.Fragment key={navItem.name}>
                    <Tooltip title={navItem.name} placement='right'>
                    <IconButton

                        component={Link}
                        to={navItem.link}
                        variant='soft'
                        color={navItem.color}
                        aria-pressed={isSelected ? 'true' : 'false'}
                        sx={theme => ({
                            ':hover': {
                                color: theme.palette[navItem.color][800]+' !important',
                            },
                            transition: 'all .2s linear',
                            // reset color for non-active
                            ':not(:hover):not([aria-pressed="true"])': {
                                backgroundColor: 'var(--variant-softBg, var(--joy-palette-neutral-softBg, var(--joy-palette-neutral-100, #F0F4F8)))',
                                color: 'var(--variant-softColor, var(--joy-palette-neutral-softColor, var(--joy-palette-neutral-700, #32383E)))',
                            }
                        })}
                    >
                        <navItem.icon />
                    </IconButton>
                    </Tooltip>
                    </React.Fragment>);

                /*
                return (
                    <ListItem key={navItem.name}>
                        <Tooltip title={navItem.name} placement='right'>
                        <ListItemButton selected={isSelected}>
                        <ListItemDecorator>
                            <IconButton variant='plain' color={navItem.color}><navItem.icon /></IconButton>
                            {/* <navItem.icon /> *\/}
                        </ListItemDecorator>
                            {/* <IconButton variant='solid' color={'contact'}><navItem.icon /></IconButton> *\/}
                        <ListItemContent sx={theme => ({display: {md: 'none'}, color: theme.palette[navItem.color][600]})}>
                            {navItem.name}
                            </ListItemContent>
                        </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )
                */
            })}

        </Stack>


        {/* This is for displaying the mobile menu */}
        <List
            size="lg"
            sx={{
                '--ListItem-radius': 'var(--joy-radius-sm)',
                '--List-gap': '4px',
                // '--Icon-fontSize': '32px'
                display: {
                    md: 'none',
                },
            }}
        >
            {navItems.map(navItem => {
                const isSelected = pathname.indexOf(navItem.link) !== -1;

                const hasAccess = navItem.hasOwnProperty('hasPermission') ? navItem.hasPermission === true : true;

                if(!hasAccess) {
                    return null;
                }

                return (
                    <ListItem key={navItem.name} component={Link} to={navItem.link} onClick={onClose}>
                        <Tooltip title={navItem.name} placement='right'>
                        <ListItemButton selected={isSelected}>
                        <ListItemDecorator>
                            <IconButton variant='plain' color={navItem.color}><navItem.icon /></IconButton>
                            {/* <navItem.icon /> */}
                        </ListItemDecorator>
                            {/* <IconButton variant='solid' color={'contact'}><navItem.icon /></IconButton> */}
                        <ListItemContent sx={theme => ({display: {md: 'none'}, color: theme.palette[navItem.color][600]})}>
                            {navItem.name}
                            </ListItemContent>
                        </ListItemButton>
                        </Tooltip>
                    </ListItem>
                )
            })}
        </List>
    </>);

}
